export const userBaseUrl = "https://dealerclick.net/api";
export const devBaseUrl = "https://dealerclick.net/dev";
export const loginBaseUrl = "https://dealerclick.net";
export const LOCAL = "http://localhost:8080";
export const LOCAL8081 = "http://localhost:8081";
